import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import EmailPreferences from "@/components/feature/EmailPreferences";

export default function EmailPreferencesPage() {
  const { user, loading } = useAuth();

  return (
    <div className="min-h-screen bg-background-50">
      <main className="mx-auto px-4 py-10 md:px-6 lg:max-w-2xl">
        <div className="mb-6 flex items-center gap-3">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-foreground-600 transition-colors hover:text-foreground-900"
          >
            <i className="ri-arrow-left-line"></i>
            Volver
          </Link>
        </div>

        <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-8">
          <div className="mb-6 flex items-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100">
              <i className="ri-mail-settings-line text-xl text-primary-500"></i>
            </span>
            <div>
              <h1 className="font-heading text-xl font-bold text-foreground-950">
                Preferencias de email
              </h1>
              <p className="text-sm text-foreground-600">
                Administrá los correos que recibís de VendeYa.
              </p>
            </div>
          </div>

          {loading || !user ? (
            <div className="flex items-center justify-center py-10">
              <i className="ri-loader-4-line animate-spin text-2xl text-primary-500"></i>
            </div>
          ) : (
            <EmailPreferences userId={user.id} />
          )}
        </div>
      </main>
    </div>
  );
}